import { takeLatest } from 'redux-saga/effects';
import {
  getLeaveListSuccess, getLeaveListFail,
  getLeaveDetailsSuccess, getLeaveDetailsFail,
  getLeaveStatSuccess, getLeaveStatFail,
  getLeavePendingListSuccess, getLeavePendingListFail,
} from './leaveState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/timekeeping/leaves');
const redirectData = {route:'/console/leaves', mode: 'list', recordId:0 };
const modelName = 'Leave';
const modelId = 'lve_id';

function* getLeaveList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getLeaveListSuccess, 
		getLeaveListFail, null, null, LOADING_MSG);
}

function* getLeaveDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getLeaveDetailsSuccess, 
		getLeaveDetailsFail, null, null, LOADING_MSG);		
}

function* getLeaveStat(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/leave-stats', data.payload), 
		getLeaveStatSuccess, 
		getLeaveStatFail, null, null, LOADING_MSG);
}

function* getLeavePendingList(data) {
	yield doCrudCall(
		() => crudService.doGetRequest('statistics/pending-leaves-list', data.payload), 
		getLeavePendingListSuccess, 
		getLeavePendingListFail, null, null, LOADING_MSG);
}

function* doLeaveCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getLeaveDetailsSuccess, 
		getLeaveDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doLeaveUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getLeaveDetailsSuccess, 
		getLeaveDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doLeaveDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getLeaveDetailsSuccess, 
		getLeaveDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* doLeaveApproval(data){
	const { recordId, typeName, typeId } = data.payload;
	const endpoint = `${recordId}/approval/${typeId}`;
	yield doCrudCall(
		() => crudService.doPostRequest(endpoint, data.payload), 
		getLeaveDetailsSuccess, 
		getLeaveDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: 'reload' }, 
		`Saving approval request ${typeName}`)		
}

function* leaveSaga() {
  yield takeLatest('leave/getLeaveList', getLeaveList);
  yield takeLatest('leave/getLeaveDetails', getLeaveDetails);
  yield takeLatest('leave/getLeaveStat', getLeaveStat);
  yield takeLatest('leave/getLeavePendingList', getLeavePendingList);
  yield takeLatest('leave/doLeaveCreate', doLeaveCreate);
  yield takeLatest('leave/doLeaveUpdate', doLeaveUpdate);
  yield takeLatest('leave/doLeaveDelete', doLeaveDelete);
  yield takeLatest('leave/doLeaveApproval', doLeaveApproval);   
}

export default leaveSaga;
